import getQueryParam from './getQueryParam';

export default function getUpscaleFromUrl(): boolean {
  const upscale = getQueryParam('upscale', '0');
  return upscale === '1';
}
